import { render, staticRenderFns } from "./DocumentsAllList.vue?vue&type=template&id=313de610&"
import script from "./DocumentsAllList.vue?vue&type=script&lang=js&"
export * from "./DocumentsAllList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsAllList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313de610')) {
      api.createRecord('313de610', component.options)
    } else {
      api.reload('313de610', component.options)
    }
    module.hot.accept("./DocumentsAllList.vue?vue&type=template&id=313de610&", function () {
      api.rerender('313de610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/documents/DocumentsAllList.vue"
export default component.exports